import React, { useState } from 'react';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { StyledFooter } from './Footer.styles';
import { ClientAccess } from '../../../ClientAccess/ClientAccess';
import { useFooter } from './useFooter';
import { DeleteClientModal } from '../../../DeleteClientModal/DeleteClientModal';

interface Props {
  isDisabled?: boolean;
  clientId: string;
}

export const Footer = ({ clientId, isDisabled }: Props) => {
  const [isClientAccessModalOpen, setIsClientAccessModalOpen] = useState(false);

  const [isDeleteClientModalOpen, setIsDeleteClientModalOpen] = useState(false);

  const { currentClient, canInviteClient, canDeleteClient } = useFooter();

  return (
    <>
      <StyledFooter as="section" data-testid="actions-footer">
        {canInviteClient && (
          <Button
            variant="secondary"
            leftIcon={currentClient.IsRegistered ? 'far fa-cog' : 'far fa-envelope-open'}
            disabled={isDisabled}
            onClick={() => setIsClientAccessModalOpen(true)}
          >
            {currentClient.IsRegistered ? 'Configure Client Access' : 'Invite Client'}
          </Button>
        )}

        <Button
          variant="secondary"
          leftIcon="far fa-arrow-circle-down"
          disabled={isDisabled}
          onClick={() => ADV.util.Router.go2('AdvancedPDF', { clientId })}
        >
          Download PDF
        </Button>

        {canDeleteClient && (
          <Button
            variant="secondary"
            leftIcon="far fa-minus-circle"
            disabled={isDisabled}
            onClick={() => setIsDeleteClientModalOpen(true)}
          >
            {currentClient.CanDeleteConsumer ? 'Delete Client' : 'Remove Client'}
          </Button>
        )}
      </StyledFooter>

      {isClientAccessModalOpen && (
        <ClientAccess clientId={clientId} onClose={() => setIsClientAccessModalOpen(false)} />
      )}

      {isDeleteClientModalOpen && (
        <DeleteClientModal clientId={clientId} onClose={() => setIsDeleteClientModalOpen(false)} />
      )}
    </>
  );
};
